import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'policy-header',
    imports: [RouterModule],
    templateUrl: './policy-header.component.html',
    styleUrl: './policy-header.component.css'
})
export class PolicyHeaderComponent {

}
